module.exports = __webpack_public_path__ + "static/img/role006.a3e0caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role006.jpg
// module id = AsDk
// module chunks = 1